import { UserEmailMinNotificationLevel } from 'dy-frontend-http-repository/lib/data/enums';

const userEmailNotificationLevelInformation: {
    [level in UserEmailMinNotificationLevel]: {
        name: string;
        description: string;
    };
} = {
    [UserEmailMinNotificationLevel.LOW]: {
        name: 'All',
        description: 'User will get all email notifications',
    },
    [UserEmailMinNotificationLevel.NORMAL]: {
        name: 'Balanced',
        description: "We'll only send notifications which require user's action",
    },
    [UserEmailMinNotificationLevel.ONLY_INVOICES]: {
        name: 'Only invoices',
        description: 'User will only receive invoice emails and critical account emails',
    },
    [UserEmailMinNotificationLevel.OFF]: {
        name: 'No email notifications',
        description:
            "We'll not send routine request notifications. Account, security, download and billing emails are still sent",
    },

    // Legacy value: shown as "All", not selectable
    [UserEmailMinNotificationLevel.HIGH]: {
        name: 'All',
        description: 'User will get all email notifications',
    },
};

export default userEmailNotificationLevelInformation;
